<mat-card appearance="raised" class="card">
  <mat-card-header class="card-header mat-elevation-z4">
    <mat-card-title class="card-header__title-container">
      <div class="avatar">{{ type === BankAccountRole.Disbursement ? 'D' : 'P' }}</div>
      <h2 class="card-header__heading">{{ title }}</h2>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mat-card-content-lg no-bottom-padding">
    <ifc-horizontal-list [items]="listItems">
    </ifc-horizontal-list>
  </mat-card-content>
</mat-card>
